<template>
  <markdown-render v-if="guide" :source="guide"></markdown-render>
</template>

<script>
import {mapState} from "vuex";
import MarkdownRender from "../../MarkdownRender";

export default {
  components: {
    "markdown-render": MarkdownRender,
  },

  computed: {
    ...mapState({
      http: (state) => state.metadata.backendApi.http[state.metadata.env],
    }),
  },
  data() {
    return {
      guide: null,
    };
  },

  mounted() {
    this.guide = "                                                                                       \n\
# Getting started for STEVAL-HARVEST1                                              \n\
Please follow instructions from [here](https://www.st.com/en/evaluation-tools/steval-harvest1.html) in order to configure properly your device \n\
## 1. TTN account  \n\
If you want to provision manual your devices on TTN, you need to create a TTN account. \n\
1. Create and login user TTN account from [TTN Console](https://console.cloud.thethings.network/) \n\
2. Create an application from the TTN Console \n\
3. Integrate your application with the asset-tracking dashboard: \n\
    - Create an API key here in this web application \n\
    - Create a custom webhook integration pointing to https://__host__base__url__/__base_path__ \n\
        - Add the authorization header and set `<api key created above>` as value \n\
        - Under 'Enabled event types', enable uplink messages events and set /data as value\n\
## 2. Provision the device \n\
### 2.1 On the dashboard \n\
On asset-tracking dashboard, from **devices** view regiester a new *STEVAL-HARVEST1* device and provide folloring inputs:    \n\
- Human-friendly label                                                                                    \n\
- Device ID                                                                               \n\
- Device EUI (reported on the MCU of your baord)                                                                            \n\
- Device profile (use the default profile for HARVEST nodes based on the refion, e.g. `default-steval-harvest-st-dsh-assetracking` for EU1)                        \n\
- In case of manual provisioning, set manual provisioning checkbox \n\
- Optional parameters which depend by your setup                                                          \n\
                                                                                                          \n\
                                                                                                          \n\
In case of usage of default device profile, remember to configure the gateway according to the frequency plan used for the region targeted by the selected device profile: \n\
  - `default` (i.e. Europe 1 (EU1) - Dublin, Ireland): `EU_863_870_TTN`.                                      \n\
  - `default-nam1` (i.e. North America 1 (NAM1) - California, USA): `US_902_928_FSB_1`.                       \n\
  - `default-au1` (i.e.  Australia 1 (AU1) - Sydney, Australia): `AU_915_928_FSB_1`.                          \n\
\n\
### 2.3 On TTN console (optional - in case of manual device provisioning)\n\
Under the application created above create an end device with the following parameters:\n\
- Input method: enter end device specifics manually\n\
- Frequency plan: Europe 863-870 MHz (SF9 for RX2 - recommended)\n\
- LoRaWAN version: LoRaWAN specification 1.0.0\n\
- Regional Parameters version: TS001 Technical Specification 1.0.0\n\
- Activation mode: Activation by personalization (ABP)\n\
- Network defaults: enable Use network's default MAC settings\n\
- DEV EUI: enter the device's unique identifier - Important: same to inserted above (2.1 section)\n\
- Dev address: enter the device's unique address - Important: last 4 bytes of DEV EUI\n\
- AppSkey: enter the device's application session key - 92C9CC7F886ABA8EB6236279194424EA\n\
- NwkSKey: enter the device's network session key - 430046937C03A083C7AED32A26EA001A\n\
- End device ID: enter the device's end ID - Important: same to inserted above (2.1 section)\n\
\n\
Once registred, access End device details view end enable Reset frame counters checkbox: > Settings tab > Network layer > Advanced MAC settings > Reset frame counters\n\
"
      .replace("__host__base__url__", this.http.host)
      .replace("__base_path__", this.http.basePath);
  },
};
</script>
